var _mask, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficeWhitePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "office-white-placeholder_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 73,
    height: 73
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 6,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#office-white-placeholder_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h73v73H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.45 50.834h6.533V21.678l-6.533 3.43v25.726zM43.85 30.253V25.19l13.883 11.842v-1.225l-16.66-17.314-13.556 6.37v4.165l-4.084 1.797v20.008h5.717V27.967h3.267v22.866h25.316v-1.715l-13.883-.735v-3.511l13.883 2.041v-1.388L43.85 42.503v-3.43l13.883 4.002v-1.388l-13.883-4.41v-4.655l13.883 7.105v-1.47L43.85 30.253z",
    fill: "#586876"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzMiIGhlaWdodD0iNzMiIHZpZXdCb3g9IjAgMCA3MyA3MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swIiBtYXNrLXR5cGU9ImFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNzMiIGhlaWdodD0iNzMiPgo8cmVjdCB3aWR0aD0iNzMiIGhlaWdodD0iNzMiIHJ4PSI2IiBmaWxsPSJ3aGl0ZSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazApIj4KPHJlY3Qgd2lkdGg9IjczIiBoZWlnaHQ9IjczIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxwYXRoIGQ9Ik0xNC40NSA1MC44MzM1SDIwLjk4MzNWMjEuNjc4NUwxNC40NSAyNS4xMDg1VjUwLjgzMzVaIiBmaWxsPSIjNTg2ODc2Ii8+CjxwYXRoIGQ9Ik00My44NSAzMC4yNTM0VjI1LjE5MDFMNTcuNzMzMyAzNy4wMzE3VjM1LjgwNjdMNDEuMDczMyAxOC40OTM0TDI3LjUxNjcgMjQuODYzNFYyOS4wMjg0TDIzLjQzMzMgMzAuODI1MVY1MC44MzM0SDI5LjE1VjI3Ljk2NjdIMzIuNDE2N1Y1MC44MzM0SDU3LjczMzNWNDkuMTE4NEw0My44NSA0OC4zODM0VjQ0Ljg3MTdMNTcuNzMzMyA0Ni45MTM0VjQ1LjUyNTFMNDMuODUgNDIuNTAzNFYzOS4wNzM0TDU3LjczMzMgNDMuMDc1MVY0MS42ODY3TDQzLjg1IDM3LjI3NjdWMzIuNjIxN0w1Ny43MzMzIDM5LjcyNjdWMzguMjU2N0w0My44NSAzMC4yNTM0WiIgZmlsbD0iIzU4Njg3NiIvPgo8L3N2Zz4K";
export { SvgOfficeWhitePlaceholder as ReactComponent };